import React from 'react';
import ImagePicker from './ImagePicker';

const Ctx = React.createContext({
    openPicker: (_opts) => {},
});

export function useImagePicker() {
    return React.useContext(Ctx);
}

function ImagePickerProvider({ children }) {
    const [open, setOpen] = React.useState(false);
    const resolverRef = React.useRef(null);
    const optsRef = React.useRef({ key: '' });

    const openPicker = (opts = {}) => {
        optsRef.current = opts;
        setOpen(true);
        return new Promise((resolve) => {
            resolverRef.current = resolve;
        });
    };

    const handleSelect = (img) => {
        const key = optsRef.current?.key;
        if (key) {
            try { localStorage.setItem(`hero_img_${key}`, img.full || img.thumb); } catch (_) {}
        }
        resolverRef.current?.(img);
        setOpen(false);
    };

    return (
        <Ctx.Provider value={{ openPicker }}>
            {children}
            <ImagePicker open={open} onClose={() => setOpen(false)} onSelect={handleSelect} />
        </Ctx.Provider>
    );
}

export default ImagePickerProvider;


